export default "__VITE_ASSET__DBAfWyB7__"